export const ORG_DETECTION_STRATEGY = {
  REGEX: 'regex',
  ORG_SELECTION: 'org_selection'
};
